<div class="overlay">
  <div class="modal" style="width: 100%; height: 100%">
    <div class="modal-content">
      <div class="flex justify-content-between flex-wrap" style="
      padding-top: 15px;
      padding-bottom: 16px;
      padding-right: 2px;
      padding-left: 70px;
      border-bottom: 1px solid #f2f4f7;
    ">
        <div class="img">
          <div class="flex justify-content-start flex-wrap">
            <div class="flex align-items-center justify-content-center mr-1">
              <img src="assets/image/auto-e-care-logo.png" alt="Logo" class="svg-black" />
            </div>
            <!-- <div class="flex align-items-center justify-content-center title">
              <p style="color: #1d2939; font-weight: 700; font-size: 18px">
                Auto <strong>E</strong> Care
              </p>
            </div> -->
          </div>
        </div>
        <!-- <div class="flex align-items-center justify-content-center">
            <p style="font-weight: 700; color: #333; font-size: 24px;">
              {{ editMode ? 'Add Service Provider Form' : 'Update Service Provider Form' }}
            </p>
          </div> -->
          <div class="flex justify-content-center flex-wrap align-items-center"> 
            <div class=" cross-icon">
               <i class="pi pi-times" style="cursor: pointer; font-size: 1em; top: 0;" (click)="close()"></i>
             </div>
          </div>   
      </div>

      <div class="flex" style="height: calc(100vh - 70px); ">
        <div class="sidebar" style="margin-top: 62px">
          <ul>
            <!-- address -->
            <li class="menu-item">
  <a (click)="setActiveSection('map-location')" 
     [ngClass]="{ active: activeSection === 'map-location' }">
    <i class="pi pi-map-marker"></i> Location
  </a>
</li>

<!-- Address Proof -->
<li class="menu-item">
  <a 
    (click)="locationComplete && setActiveSection('address-proof')" 
    [class.disabled]="!locationComplete"
    [ngClass]="{
      active: activeSection === 'address-proof',
      disabled: !locationComplete
    }">
    <i class="pi pi-address-book"></i> Address Proof
  </a>
</li>

<!-- Business Details -->
<li class="menu-item">
  <a 
    (click)="addressProofComplete && setActiveSection('business-details')" 
    [class.disabled]="!addressProofComplete"
    [ngClass]="{
      active: activeSection === 'business-details',
      disabled: !addressProofComplete
    }">
    <i class="pi pi-bars"></i> Business Details
  </a>
</li>

<!-- Owner/Incharge Details -->
<li class="menu-item">
  <a 
    (click)="businessDetailsComplete && setActiveSection('owner-details')" 
    [class.disabled]="!businessDetailsComplete"
    [ngClass]="{
      active: activeSection === 'owner-details',
      disabled: !businessDetailsComplete
    }">
    <i class="pi pi-user"></i> Owner/Incharge Details
  </a>
</li>
           
          </ul>
        </div>
        <div class="content" style="flex-grow: 1;">
          <app-map-location *ngIf="activeSection === 'map-location'" (nextSection)="setActiveSection('address-proof')"
            [formStateService]="formstate" [formSource]="'Distributor'"></app-map-location>
          <app-addressproof *ngIf="activeSection === 'address-proof'"
            (nextSection)="setActiveSection('business-details')" [formStateService]="formstate"
            [formSource]="'Distributor'"></app-addressproof>
          <app-distributor-business-details [phoneNumber]="phoneNumber" [idRecieved]="id"
            *ngIf="activeSection === 'business-details'" (nextSection)="setActiveSection('owner-details')">
          </app-distributor-business-details>

          <app-distributors-sponsor-owner-details *ngIf="activeSection === 'owner-details'" [idRecieved]="id"
            [phoneNumber]="phoneNumber" (close)="close()" (updateList)="onUpdateServiceDistributorList()"
            (nextSection)="handleFinish()"></app-distributors-sponsor-owner-details>

        </div>
      </div>
    </div>
  </div>
</div>